if (!customElements.get('background-video')) {
	class BackgroundVideo extends HTMLElement {
		connectedCallback() {
			this.frame = requestAnimationFrame(() => this.initialize());
		}

		initialize() {
			this.events?.abort();
			this.events = new AbortController();
			const container = this.querySelector('.background-video__iframe');
			if (!container) return;
			const video = container.querySelector('video');
			if (video) {
				const showVideo = () => container.classList.add('is-playing');
				video.addEventListener('playing', showVideo, { signal: this.events.signal });
				if (!video.paused && video.readyState >= 2) showVideo();
				if (!video.hasAttribute('data-deferred-video')) return;
				if (navigator.connection?.saveData || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
				const loadVideo = () => {
					this.observer?.disconnect();
					video.querySelectorAll('source[data-src]').forEach(source => {
						source.src = source.dataset.src;
						delete source.dataset.src;
					});
					video.removeAttribute('data-deferred-video');
					video.muted = true;
					video.preload = 'auto';
					video.load();
					video.play()?.catch(() => {});
				};
				this.observer = new IntersectionObserver(entries => {
					if (entries.some(entry => entry.isIntersecting)) loadVideo();
				}, { rootMargin: '200px' });
				this.observer.observe(this);
			}
			const iframe = container.querySelector('iframe');
			iframe?.addEventListener('load', () => {
				const command = container.dataset.provider === 'youtube'
					? { event: 'command', func: 'playVideo', args: '' }
					: { method: 'play' };
				iframe.contentWindow.postMessage(JSON.stringify(command), '*');
			}, { signal: this.events.signal });
		}

		disconnectedCallback() {
			cancelAnimationFrame(this.frame);
			this.events?.abort();
			this.observer?.disconnect();
		}
	}
	customElements.define('background-video', BackgroundVideo);
}
